export default "__VITE_ASSET__BrHPFzRS__"